import { Component, OnInit } from '@angular/core';
import { FooterCTAService } from '../../../services/footer-cta.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  constructor(private footerCTAService: FooterCTAService) {}

  ngOnInit(): void {
    this.footerCTAService.callFooterMethod(false);
  }
}
